import React, { Component } from "react";
import numeral from "numeral";
import { CircleProgress } from "reactackle";
import { LazyLoadImage } from "react-lazy-load-image-component";
import PhotoCard from "./PhotoCard";
import SingleRecord from "../SingleRecord/SingleRecord";

class MyShopCard extends Component {
  state = {
    editMode: false
  };
  getPhotos = photos => {
    if (photos && photos.length > 0) {
      return photos.map((photo, index) => {
        if (photo.status === "DONE") {
          return (
            <div style={{ backgroundColor: "white" }}>
              <LazyLoadImage src={photo.url} style={{ minHeight: "200px" }} />
            </div>
          );
        } else {
          return (
            <div style={{ padding: "40px", backgroundColor: "white" }}>
              <CircleProgress
                indeterminate
                subtitle="Updating..."
                labelPositionX={"center"}
                labelPositionY={"bottom"}
              />
            </div>
          );
        }
      });
    }
  };

  getMobileDiv = rec => {
    //console.log(JSON.stringify(rec));
    return (
      <div>
        <div
          style={{
            margin: "0px",
            fontSize: "16px",
            fontWeight: "bold",
            textTransform: "uppercase",
            width: "100%",
            padding: "10px",
            paddingBottom: "0px"
          }}
        >
          {rec.productNameEnglish}
        </div>
        <div
          style={{
            marginTop: "1px"
          }}
        >
          <span
            style={{
              marginTop: "1px",
              marginBottom: "0px",
              marginLeft: "10px",
              fontSize: "14px",
              textTransform: "uppercase",
              backgroundColor: "black",
              padding: "2px",
              borderRadius: "2px",
              color: "white",
              paddingLeft: "10px",
              paddingRight: "10px"
            }}
          >
            ${numeral(rec.productPrice).format("0,0.00")}
          </span>
          <span
            style={{
              marginTop: "1px",
              marginBottom: "0px",
              marginLeft: "1px",
              fontSize: "12px",
              textTransform: "uppercase",
              backgroundColor: "white",
              padding: "2px",
              borderRadius: "2px",
              color: "black"
            }}
          >
            {rec.unit}
          </span>
        </div>
        <div
          style={{
            marginLeft: "1px",
            marginRight: "1px"
          }}
        >
          <PhotoCard photos={rec.photos} />
        </div>
        <div
          style={{
            color: "#333",
            fontSize: "14px",
            backgroundColor: "rgb(30, 101, 144)",
            padding: "5px",
            borderRadius: "5px",
            color: "white",
            margin: "5px",
            textAlign: "center"
          }}
        >
          <div
            onClick={() => {
              this.props.handleEdit(rec.key, this.props.tableName, rec);
              this.setState({ editMode: true });
            }}
          >
            CHANGE
          </div>
        </div>
      </div>
    );
  };

  getEditView = () => {
    return (
      <div
        style={{
          marginTop: "-60px"
        }}
      >
        <SingleRecord
          path={this.props.tableName}
          handleEditCancel={() => {
            this.setState({ editMode: false });
          }}
          handleDelete={this.props.handleDelete}
          ogTableDef={this.props.ogTableDef}
          genNotification={this.props.genNotification}
          cellPhone={this.props.refPhoneNumber}
        />
      </div>
    );
  };

  render() {
    if (this.state.editMode) {
      return (
        <div
          style={{
            background: "#FFFFFF",
            border: "1.5px solid #ccc",
            boxSizing: "border-box",
            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
            borderRadius: "10px",
            marginBottom: "10px",
            marginRight: "5px",
            marginLeft: "5px",
            padding: "2px"
          }}
        >
          {this.getEditView()};
        </div>
      );
    } else {
      return (
        <div
          style={{
            background: "#FFFFFF",
            border: "1.5px solid #ccc",
            boxSizing: "border-box",
            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
            borderRadius: "10px",
            marginBottom: "10px",
            marginRight: "5px",
            marginLeft: "5px",
            padding: "2px"
          }}
        >
          {this.getMobileDiv(this.props.data)};
        </div>
      );
    }
  }
}

export default MyShopCard;



// WEBPACK FOOTER //
// ./src/app/components/Screens/ContentGrid/MyShopCard.jsx